// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e17be122","703":"b9dedebe"}[chunkId] + ".chunk.js";
};